import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "discounts-overview bg-white rounded" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center bg-light mb-3 p-2 rounded" }
const _hoisted_3 = { class: "d-flex align-items-center fs-3 m-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1 me-3" }, "production_quantity_limits", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "mas ms-n1 me-1" }, "add", -1)
const _hoisted_6 = { class: "table table-hover align-middle" }
const _hoisted_7 = { class: "border-dark border-bottom pb-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", { class: "col-1" }, null, -1)
const _hoisted_9 = { class: "col-2" }
const _hoisted_10 = { class: "col-1" }
const _hoisted_11 = { class: "col-1" }
const _hoisted_12 = { class: "col-1" }
const _hoisted_13 = { class: "col-1" }
const _hoisted_14 = { class: "col-1" }
const _hoisted_15 = { class: "col-1" }
const _hoisted_16 = { class: "col-1" }
const _hoisted_17 = { class: "col-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", { class: "col-1" }, null, -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  colspan: "11",
  class: "fw-bold small text-uppercase text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_checkbox_boolean = _resolveComponent("input-checkbox-boolean")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_ShoppingCartDiscountsOverviewItem = _resolveComponent("ShoppingCartDiscountsOverviewItem")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('shoppingCartDiscounts')), 1)
      ]),
      _createVNode(_component_dp_form, {
        as: "form",
        novalidate: ""
      }, {
        default: _withCtx(({ errors }) => [
          _createVNode(_component_input_checkbox_boolean, {
            modelValue: _ctx.hidePromoCodeInputField,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hidePromoCodeInputField) = $event)),
            label: _ctx.$t('hidePromoCodeInputField'),
            name: _ctx.$t('hidePromoCodeInputField'),
            errors: errors,
            onChange: _ctx.updateHidePromoField
          }, null, 8, ["modelValue", "label", "name", "errors", "onChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: {name: 'new-shopping-cart-discount'},
        class: "btn btn-icon btn-primary d-flex align-items-center"
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(_toDisplayString(_ctx.$t('new')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("table", _hoisted_6, [
      _createElementVNode("thead", _hoisted_7, [
        _createElementVNode("tr", null, [
          _hoisted_8,
          _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('name')), 1),
          _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('promoCode')), 1),
          _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('minimumPurchaseAmount')), 1),
          _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('type')), 1),
          _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('value')), 1),
          _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('clientGroup')), 1),
          _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('from')), 1),
          _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('till')), 1),
          _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('usage')), 1),
          _hoisted_18
        ])
      ]),
      _createElementVNode("tbody", null, [
        (!_ctx.isReady)
          ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
              key: 0,
              "n-cols": 11
            }))
          : (!_ctx.hasShoppingCartDiscountSchemes)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.$t('noContentFound')), 1)
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.shoppingCartDiscountSchemes, (shoppingCartDiscountScheme) => {
                return (_openBlock(), _createBlock(_component_ShoppingCartDiscountsOverviewItem, {
                  key: shoppingCartDiscountScheme.id,
                  data: shoppingCartDiscountScheme,
                  onDeleteShoppingCartDiscountScheme: _ctx.deleteShoppingCartDiscountScheme
                }, null, 8, ["data", "onDeleteShoppingCartDiscountScheme"]))
              }), 128))
      ])
    ])
  ]))
}